/** Plain-English partner roles. The partner's own team works the "Agent desk". */
export const ROLE_LABELS = {
    partner_admin: 'Administrator',
    partner_staff: 'Agent staff',
    partner_referrer: 'Referring broker',
};
/** Sidebar subtitle for each portal. */
export const DESK_SECTION = 'Agent desk';
export const REFERRER_SECTION = 'Broker portal';
/**
 * The partner's own words for the two sides, with the defaults above for a
 * buyer's agent referred to by brokers. A broker office referred to by agents
 * seeds `vocabulary` the other way round.
 */
export function vocabularyOf(profile) {
    const v = profile?.vocabulary ?? {};
    return {
        referrer: v.referrer || 'broker',
        referrers: v.referrers || 'brokers',
        referrerRoleLabel: v.referrerRoleLabel || ROLE_LABELS.partner_referrer,
        deskLabel: v.deskLabel || DESK_SECTION,
        portalLabel: v.portalLabel || REFERRER_SECTION,
    };
}
export function roleLabel(role, vocab) {
    return role === 'partner_referrer' ? vocab.referrerRoleLabel : ROLE_LABELS[role];
}
